const VISITOR_KEY = '_portfolio_visitor'
const BROWSER_KEY = '_portfolio_browser_id'
const UTM_KEY = '_portfolio_utm'

export const getBrowserId = () => {
  try {
    let id = localStorage.getItem(BROWSER_KEY)
    if (!id) {
      id = typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`
      localStorage.setItem(BROWSER_KEY, id)
    }
    return id
  } catch {
    return null
  }
}

export const slugifyName = (name) => {
  if (!name || typeof name !== 'string') return null
  const slug = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
  return slug || null
}

export const getVisitorName = () => {
  try {
    return localStorage.getItem(VISITOR_KEY) || null
  } catch {
    return null
  }
}

export const setVisitorName = (name) => {
  const slug = slugifyName(name)
  if (!slug) return false

  try {
    if (localStorage.getItem(VISITOR_KEY)) return false
    localStorage.setItem(VISITOR_KEY, slug)
    return true
  } catch {
    return false
  }
}

export const formatDisplayName = (slug) => {
  if (!slug) return null
  return slug
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}

export const getVisitorKey = (sessionId) => getVisitorName() || sessionId || 'unknown'

export const captureVisitorFromUrl = (search) => {
  try {
    const ref = new URLSearchParams(search).get('ref')
    if (ref) return setVisitorName(ref)
  } catch {
    return false
  }
  return false
}

export const captureVisitorFromParam = (visitorName) => setVisitorName(visitorName)

export const captureUtmParams = () => {
  try {
    const stored = sessionStorage.getItem(UTM_KEY)
    if (stored) return JSON.parse(stored)

    const params = new URLSearchParams(window.location.search)
    const utm = {
      utm_source: params.get('utm_source') || null,
      utm_medium: params.get('utm_medium') || null,
      utm_campaign: params.get('utm_campaign') || null,
    }

    if (utm.utm_source || utm.utm_medium || utm.utm_campaign) {
      sessionStorage.setItem(UTM_KEY, JSON.stringify(utm))
    }

    return utm
  } catch {
    return { utm_source: null, utm_medium: null, utm_campaign: null }
  }
}

export const getStoredUtm = () => {
  try {
    const stored = sessionStorage.getItem(UTM_KEY)
    if (stored) return JSON.parse(stored)
  } catch {
    return { utm_source: null, utm_medium: null, utm_campaign: null }
  }
  return { utm_source: null, utm_medium: null, utm_campaign: null }
}
